import React from 'react';
import { Table, Thumbnail } from '@bynder/design-system';
import { Template } from 'packages/store/templates/types';
import { IdentityRole } from 'packages/store/sharing/types';
import { Box } from './TitleCell.styled';
import { contentIconMap } from '../../card/utils';
import { AllowedIndicatorTypes } from 'packages/pages/components/templates/types';
import { getTemplateIcon } from 'packages/pages/components/templates/utils';

const PROCESSED_STATUSES = ['PROCESSED', 'NOT_FOUND', 'FAILED'];

const TemplateTitleCell = ({
    template,
    isCategoryDetails,
    allowedIndicatorTypes,
}: {
    template: Template;
    isCategoryDetails: boolean;
    allowedIndicatorTypes?: AllowedIndicatorTypes;
}) => {
    const isProcessingDone = PROCESSED_STATUSES.includes(template.thumbnailStatus);

    const imageUrl = () => {
        if (template.thumbnailImage) {
            return template.thumbnailImage;
        }

        return '';
    };

    return (
        <Table.Cell
            thumbnail={
                !isProcessingDone ? (
                    <Thumbnail variant="clean" icon={contentIconMap[template.creativeType]}>
                        <Thumbnail.Overlay isLoading />
                    </Thumbnail>
                ) : (
                    <>
                        {imageUrl() ? (
                            <Thumbnail variant="content" imageUrl={imageUrl()} />
                        ) : (
                            <Thumbnail variant="clean" icon={contentIconMap[template.creativeType]} />
                        )}
                    </>
                )
            }
        >
            <Box style={{ position: 'relative' }}>
                <div>{template.name}</div>
                <div>{getTemplateIcon(template, isCategoryDetails, IdentityRole.CAN_USE, allowedIndicatorTypes)}</div>
            </Box>
        </Table.Cell>
    );
};

export default TemplateTitleCell;
